import API from "./api";

const DEFAULT_TTL_MS = 20000;
export const CURRENT_USER_CACHE_EVENT = "current-user-cache-updated";

const cache = {
  accountSets: { data: null, ts: 0, promise: null },
  currentUser: { data: null, ts: 0, promise: null },
};

function emitCurrentUserCacheUpdate(data) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CURRENT_USER_CACHE_EVENT, { detail: data || null }));
}

function isFresh(entry, ttlMs = DEFAULT_TTL_MS) {
  return entry.data && entry.ts && Date.now() - entry.ts < ttlMs;
}

function normalizeAccountSets(res) {
  const data = res?.data?.data || res?.data;
  return Array.isArray(data) ? data : [];
}

export async function getAccountSets({ force = false, ttlMs = DEFAULT_TTL_MS } = {}) {
  if (!force && isFresh(cache.accountSets, ttlMs)) return cache.accountSets.data;
  if (cache.accountSets.promise) return cache.accountSets.promise;

  cache.accountSets.promise = API.get("/account-sets")
    .then((res) => {
      const data = normalizeAccountSets(res);
      cache.accountSets.data = data;
      cache.accountSets.ts = Date.now();
      return data;
    })
    .finally(() => {
      cache.accountSets.promise = null;
    });

  return cache.accountSets.promise;
}

export function setAccountSetsCache(data) {
  cache.accountSets.data = Array.isArray(data) ? data : [];
  cache.accountSets.ts = Date.now();
}

export function invalidateAccountSetsCache() {
  cache.accountSets.data = null;
  cache.accountSets.ts = 0;
}

export async function getCurrentUser({ force = false, ttlMs = DEFAULT_TTL_MS } = {}) {
  if (!force && isFresh(cache.currentUser, ttlMs)) return cache.currentUser.data;
  if (cache.currentUser.promise) return cache.currentUser.promise;

  cache.currentUser.promise = API.get("/users/me")
    .then((res) => {
      cache.currentUser.data = res?.data || null;
      cache.currentUser.ts = Date.now();
      return cache.currentUser.data;
    })
    .finally(() => {
      cache.currentUser.promise = null;
    });

  return cache.currentUser.promise;
}

export function setCurrentUserCache(data) {
  cache.currentUser.data = data || null;
  cache.currentUser.ts = Date.now();
  emitCurrentUserCacheUpdate(cache.currentUser.data);
}

export function invalidateCurrentUserCache() {
  cache.currentUser.data = null;
  cache.currentUser.ts = 0;
  emitCurrentUserCacheUpdate(null);
}
